import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles(({
	container: {
		display: "flex"
	},
	button: {
		margin: "30px auto",
		...ColorUtil.getBackgroundAndContrastColor(themeColors.getPrimaryColor()),
		width: "300px",
		padding: "18px 40px",
		borderRadius: "50px",
		color: themeColors.colors.base.white,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(themeColors.getPrimaryColor())
		}
	},
	calloutTitle: {
		fontSize: "40px",
		color: themeColors.getPrimaryColor(),
		fontWeight: 600,
		lineHeight: "normal",
		marginBottom: "20px"
	},
	calloutImage: {
		width: "-webkit-fill-available"
	},
	listedItem: {
		marginTop: "5px"
	},
	bulletedListContainer: {
		margin: "16px 0 16px 25px"
	},
	alertText: {
		color: themeColors.getPrimaryColor(),
		fontWeight: 600
	},
	alertContainer: {
		margin: "16px 0 50px 0"
	},
	planTag: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.system.yellow[300]),
		fontWeight: 600,
		color: colors.gray[700],
		cursor: "inherit",
		fontSize: "14px",
		height: "20px",
		marginBottom: "20px",
		padding: "20px",
		justifyContent: "center",
		borderRadius: "30px"
	}
}))

export default useStyles
